import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserGuard } from './shared/guards/user.guard';

const routes: Routes = [
  // this is just here as an example
  // {path: 'admin', canLoad: [ SystemAdministratorGuard, ], loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)},
  {
    path: '',
    // pathMatch: 'full',
    canLoad: [UserGuard],
    // component: DashboardComponent,
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardModule)
  },
  {
    path: 'production',
    canLoad: [UserGuard],
    // component: AppointmentComponent
    loadChildren: () =>
      import('./production/production.module').then((m) => m.ProductionModule)
  },
  {
    path: 'pos',
    canLoad: [UserGuard],
    // component: AppointmentComponent
    loadChildren: () =>
      import('./modules/pos/pos.module').then((m) => m.PosModule)
  },
  {
    path: 'online',
    canLoad: [UserGuard],
    // component: AppointmentComponent
    loadChildren: () =>
      import('./modules/online/online.module').then((m) => m.OnlineModule)
  },
  {
    path: 'scanner',
    canLoad: [UserGuard],
    // component: AppointmentComponent
    loadChildren: () =>
      import('./scanner/scanner.module').then((m) => m.ScannerModule)
  }
  // {path: 'test/guard/user', component: ProductionComponent, canActivate: [UserGuard]},
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { anchorScrolling: 'enabled', useHash: false })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
